import Konva from 'konva'
import React, { useContext } from 'react'
import { Stage, Layer, Shape, Rect } from 'react-konva'
import cx from 'classnames'

import WheelGraphFooter from './WheelGraphFooter'
import GraphContext, { GraphContextType } from './GraphContext'
import PrintContext, { PrintContextType } from './PrintContext'
import { getDrawItV2, getDrawItV1 } from './math'
import UserContext, { UserContextType } from './UserContext'

interface Props {
  width: number
  toggleIsAnimate: () => void
  isEditing: boolean
}

const WheelGraph = ({ width, toggleIsAnimate, isEditing }: Props) => {
  const {
    userContext: { version, isFullscreen },
  } = useContext(UserContext) as UserContextType
  const { printContext } = useContext(PrintContext) as PrintContextType
  const { isAnimate } = printContext
  const isShowFooter = !(isFullscreen && isAnimate)
  const {
    graphContext: { graphConfig: config, graphRef: stageRef, isLog, frameCount },
  } = useContext(GraphContext) as GraphContextType
  const {
    strokeColor,
    strokeWidth,
    fillColor,
    bgColor,
    isUseBgColor,
    isFillShape,
    isVisibleStroke,
  } = config
  const isV1 = version === '1.0.0'
  const drawIt = (isV1 ? getDrawItV1 : getDrawItV2)({ width, config, isLog })
  const sceneFunc = (context: Konva.Context, shape: Konva.Shape) => {
    if (isFillShape) {
      context.beginPath()
      drawIt(context)
      context.closePath()
      context.fillStrokeShape(shape)
    } else {
      context.beginPath()
      context.closePath()
      drawIt(context)
      context.strokeShape(shape)
    }
  }
  const onClick = () => {
    if (isEditing) {
      // ignore; too easy to trigger when clicking out of an input (esp. color picker)
    } else {
      toggleIsAnimate()
    }
  }
  const stageClass = cx('stage', { clickable: !isEditing && frameCount > 1 })
  return (
    <>
      <Stage
        width={width}
        height={width}
        className={stageClass}
        ref={stageRef}
        onClick={onClick}
        onTouchStart={onClick}
      >
        <Layer>
          {isUseBgColor && <Rect width={width} height={width} fill={bgColor}></Rect>}
          <Shape
            sceneFunc={sceneFunc}
            fill={fillColor}
            stroke={isVisibleStroke ? strokeColor : bgColor}
            strokeWidth={strokeWidth}
          />
        </Layer>
        {isShowFooter && (
          <WheelGraphFooter printContext={printContext} config={config} width={width} />
        )}
      </Stage>
    </>
  )
}

export default WheelGraph
